<ng-content select="passedText"></ng-content
><ng-container *ngIf="enabledForScreenSize"
    ><div class="d-inline-block text-cyan-blue pointer" *ngIf="collapsed" (click)="readMore()">&nbsp; ...Read More</div>
    <div class="d-inline-block text-cyan-blue pointer" *ngIf="!collapsed" (click)="readLess()">&nbsp; Read Less...</div></ng-container
>
